<script>
import {PolicyTutorContent, TutorType} from "../../../../../core/option/tutorOption";

export default {
  name: "MilitaryDetail",
  props:{
    task: {
      type: Object,
      default: () => {}
    }
  },
  data(){
    return{
      details:{},
      WRITING_REVIEW: PolicyTutorContent.WRITING_REVIEW,
      OTHER_SUPPORT: PolicyTutorContent.OTHER_SUPPORT,
      TutorType: TutorType
    }
  },
  methods:{
    copyContent(copyContent){
      navigator.clipboard.writeText(copyContent)
      this.$message({
        showClose: true,
        message: 'Sao chép thành công',
        type: 'success'
      });
    },
    getPolicyTitle(type) {
      switch (type) {
        case PolicyTutorContent.WRITING_REVIEW:
          return 'Chấm & sửa bài Writing';
        case PolicyTutorContent.IELTS_SPEAKING_PRACTICE:
          return 'Luyện kỹ năng Speaking';
        case PolicyTutorContent.VOCABULARY_PRONUNCIATION:
          return 'Luyện từ vựng & phát âm';
        case PolicyTutorContent.LISTENING_METHOD:
          return 'Phương pháp học Listening';
        case PolicyTutorContent.PRONUNCIATION_METHOD:
          return 'Phương pháp luyện phát âm';
        case PolicyTutorContent.GRAMMAR_METHOD:
          return 'Phương pháp học ngữ pháp';
        case PolicyTutorContent.VOCABULARY_METHOD:
          return 'Phương pháp học từ vựng';
        case PolicyTutorContent.LISTENING_EXAM_PRACTICE:
          return 'Phương pháp luyện đề Listening';
        case PolicyTutorContent.READING_EXAM_PRACTICE:
          return 'Phương pháp luyện đề Reading';
        case PolicyTutorContent.WRITING_EXAM_PRACTICE:
          return 'Phương pháp luyện đề Writing';
        case PolicyTutorContent.SPEAKING_EXAM_PRACTICE:
          return 'Phương pháp luyện đề Speaking';
        case PolicyTutorContent.OTHER_SUPPORT:
          return 'Bổ trợ khác';
        default:
          return this.details?.content??'';
      }
    }
  },
  mounted() {
  this.details = this.task?.detail
  }
}
</script>

<template>
  <div class="col-md-12 px-6">
    <div
        style="border:1px solid #D6D5D5; border-radius: 5px; background-color: #F6F6F6"
        class="px-3 py-5 w-100 row"
    >
      <div class="col-md-6 mb-4">
        <p>Mã tác vụ</p>
        <el-input placeholder="-"  :value="task?.id"></el-input>
      </div>

      <div class="col-md-6 mb-4">
        <p>Phân loại</p>
        <el-input placeholder="-"  :value="task?.subtype_label"></el-input>
      </div>

      <div class="col-md-6 mb-4">
        <p>Nội dung gia sư</p>
        <el-input
            placeholder="-"

            :value="getPolicyTitle(details?.content_id)"
        ></el-input>
      </div>
      <div class="col-md-6 mb-4" v-if="this.task?.subtype === TutorType.PolicyTutor && details?.content_id === OTHER_SUPPORT " >
        <p>Nội dung chi tiết</p>
        <div style="cursor: pointer">
          <el-tooltip class="item" effect="dark" :content="details?.content" placement="top-end">
          <el-input
              placeholder="-"
              readonly
              :value="details?.content"
          ></el-input>
          </el-tooltip>
        </div>

      </div>
      <div class="col-md-6 mb-4" v-if="this.task?.subtype === TutorType.PolicyTutor && details?.content_id === WRITING_REVIEW " >
        <p>Link bài writing cần sửa</p>
        <div style="position: relative">
          <el-input
              placeholder="-"

              :value="details?.content"
          ></el-input>
          <i @click="copyContent(details?.content)" class="el-icon-document-copy"  style="position: absolute; right: 2px;font-size: 25px; top: 7px;cursor: pointer" title="Sao chép"></i>
        </div>

      </div>

      <div class="col-md-6 mb-4">
        <p>Ngày làm</p>
        <el-input placeholder="-"  :value="details?.date"></el-input>
      </div>

      <div class="col-md-6 mb-4">
        <p>Thời gian bắt đầu</p>
        <el-input placeholder="-"  :value="details?.start_time" ></el-input>
      </div>

      <div class="col-md-6 mb-4">
        <p>Thời gian kết thúc</p>
        <el-input placeholder="-"  :value="details?.end_time"></el-input>
      </div>

      <div class="col-md-6 mb-4">
        <p>Trình độ học</p>
        <el-input placeholder="-" :value="task?.level_out_name" ></el-input>
      </div>

      <div class="col-md-6 mb-4">
        <p>Chi nhánh học</p>
        <el-input placeholder="-"  :value="task?.branch_name"></el-input>
      </div>
      <div class="col-md-6 mb-4">
        <p>Họ và tên khách hàng</p>
        <div style="position: relative">
          <el-input placeholder="-" :value="task?.user_name"></el-input>
          <router-link :to="`/customer-crm/detail/${task?.user_id}?best_customer_id=${task?.best_customer_id}&active_name=cskh`" target="_blank" class="watch-detail" >Xem chi tiết</router-link>

        </div>
      </div>

      <div class="col-md-6 mb-4">
        <p>Số điện thoại khách hàng</p>
        <el-input placeholder="-"  :value="task?.user_phone"></el-input>
      </div>
    </div>
  </div>

</template>

<style >
.el-tooltip__popper{
  max-width: 400px!important;
}
.watch-detail{
  position: absolute;
  right: 12px;
  top: 50%;
  transform: translateY(-50%);
  color: #0066FF;
  cursor: pointer;
  font-weight: 600;
}

</style>